module.exports = __webpack_public_path__ + "static/media/img4.7ed8e381.png";